import { render } from "./Door.vue?vue&type=template&id=05387808&scoped=true"
import script from "./Door.vue?vue&type=script&lang=js"
export * from "./Door.vue?vue&type=script&lang=js"

import "./Door.vue?vue&type=style&index=0&id=05387808&scoped=true&lang=css"

import exportComponent from "/home/hakii/application-form-proto-admin-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05387808"]])

export default __exports__